module.exports = __webpack_public_path__ + "img/bhv.b78a5f6c.svg";